import NRReactGrid from '../../components/NRReactGrid/NRReactGrid';
import Box from '@mui/material/Box';
import { forwardRef } from 'react';
import { VulnerabilitiesBarProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/VulnerabilitiesBarProvider/VulnerabilitiesBarProvider';
import { NRSBOMNameProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRSBOMNameProvider';
import { NRSBOMVersionProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRSBOMVersionProvider';
import { NRSBOMTypeProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRSBOMTypeProvider';
import { NRSBOMScopeProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRSBOMScopeProvider';
import { ExploitsProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/ExploitsProvider/ExploitsProvider';
import { NRSBOMDependenciesProvider } from './NRSBOMCustomComponents/NRSBOMBInfoProvider';
import { NRSBOMLicenseProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRSBOMLicenseProvider';
import { EnhancedCorrelationsProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/EnhancedCorrelationsProvider';
import { ASSET_CORRELATION_TYPE } from '../../graphql/queries/assetCorrelations';
import { NRUserModificationProvider } from './NRSBOMCustomComponents/NRUserModificationProvider';
import { NRConfidenceProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRConfidenceProvider';
import { NRVerificationProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRVerificationProvider/NRVerificationProvider';
import { NRIdentificationProvider } from '../../components/NRReactGridCustomComponents/NRCustomProviders/NRIdentificationProvider/NRIdentificationProvider';
import { BooleanCheckProvider } from './NRSBOMCustomComponents/BooleanCheckProvider';

function NRSBOMTable(
  {
    loading,
    rows,
    columns,
    columnExtensions,
    title,
    showSelect = true,
    pageSize,
    hasCursorPagination,
    showIntegratedPagination,
    titleExtraComponent,
    customClass,
    defaultSortingColumn,
    defaultSortingOrder,
    totalCount,
    paginationTotalCountLoading,
    handleFetchMore,
    pageInfo,
    onSortingChange,
    handleFiltersChange,
    preSettedFilters,
    embedded = false,
    showIntegratedSelection = true,
    onChangeFiltersVisibility,
    sbomTableKey,
    sortingColumnNames,
    selectAllFetchConfig,
    dependenciesCount,
    hasExtraActions,
    selectionCell,
    sx,
    selectAllAriaLabel,
    showIdentifiedVia = false,
    showConfidence = false,
    externalHiddenColumnNames
  },
  ref
) {
  return (
    <Box sx={{ mt: 1, ...sx }}>
      <NRReactGrid
        ref={ref}
        loading={loading}
        rows={rows}
        columns={columns}
        columnExtensions={columnExtensions}
        title={title}
        hasExtraActions={hasExtraActions}
        providersArray={[
          <VulnerabilitiesBarProvider
            extraParams={{
              handleIsLoading: row => {
                return row?.userModification?.status === 'UPDATING';
              }
            }}
            key="VulnerabilitiesBarProvider"
            for={['vulnerability']}
          />,
          <NRSBOMNameProvider key="name" for={['name']} />,
          <NRSBOMVersionProvider key="version" for={['version']} />,
          <NRSBOMLicenseProvider key="version" for={['license']} />,
          <NRSBOMTypeProvider key="type" for={['type']} />,
          <NRSBOMScopeProvider key="scope" for={['scope']} />,
          <ExploitsProvider key="exploit" for={['exploit']} />,
          ...(showIdentifiedVia ? [] : [<NRVerificationProvider key="verification" for={['verification']} />]),
          ...(showIdentifiedVia ? [<NRIdentificationProvider key="identifiedVia" for={['identifiedVia']} />] : []),
          <EnhancedCorrelationsProvider
            key="CorrelationsProvider"
            for={['correlations']}
            extraParams={{
              assetCorrelationType: ASSET_CORRELATION_TYPE.COMPONENT,
              getListAssetCorrelationsIdentifier: row => row.dependency?.id
            }}
          />,
          <NRSBOMDependenciesProvider key="dependencies" for={['dependencies']} />,
          <BooleanCheckProvider key={'onDisk'} for={['onDisk']} />,
          <NRUserModificationProvider key="latestRemediation" for={['latestRemediation']} />,
          ...(showConfidence ? [<NRConfidenceProvider key="confidence" for={['confidence']} />] : [])
        ]}
        showSelectAll={showSelect}
        pageSize={pageSize}
        preSettedFilters={preSettedFilters}
        hasCursorPagination={hasCursorPagination}
        showIntegratedPagination={showIntegratedPagination}
        titleExtraComponent={titleExtraComponent}
        customClass={customClass}
        defaultSortingColumn={defaultSortingColumn}
        defaultSortingOrder={defaultSortingOrder}
        totalCount={totalCount}
        paginationTotalCountLoading={paginationTotalCountLoading}
        handleFetchMore={handleFetchMore}
        pageInfo={pageInfo}
        onSortingChange={onSortingChange}
        embedded={embedded}
        handleFiltersChange={handleFiltersChange}
        showIntegratedSelection={showIntegratedSelection}
        onChangeFiltersVisibility={onChangeFiltersVisibility}
        tableStorageId={sbomTableKey}
        sortingColumnNames={sortingColumnNames}
        selectAllFetchConfig={selectAllFetchConfig}
        selectionCell={selectionCell}
        selectAllAriaLabel={selectAllAriaLabel}
        externalHiddenColumnNames={externalHiddenColumnNames}
      />
    </Box>
  );
}
export default forwardRef(NRSBOMTable);
